$(function () {
    $('.play').on('click', function () {
        $(this).hide();
        $(this).siblings('video').attr('controls', '');
        $(this).siblings('video').get(0).play();
    })
});
